import React from 'react';
import { StatusBar } from 'react-native';
import SafeAreaView from 'atoms/SafeAreaView';

export default function MobileStatusBar() {
  return (
    <>
      <StatusBar barStyle="light-content" />
      <SafeAreaView />
    </>
  );
}
